const MINIMUM_ATH_COUNT_IN_ROSTER = 20

export {
    MINIMUM_ATH_COUNT_IN_ROSTER,
}
